export default __webpack_public_path__ + "static/media/Ballroll_00093.24a347ac.png";